import Footer from '@components/Footer/Footer';
import Header from '@components/Header/Header';
import ScrollDown from '@components/ScrollDown/ScrollDown';
import { useScrollSelector } from '@gluedigital/scrollastic';
import { useRef } from 'react';
import Contact from './sections/Contact/Contact';
import DataFacts from './sections/DataFacts/DataFacts';
import Designed from './sections/Designed/Designed';
import HeroAnimation from './sections/HeroAnimation/HeroAnimation';
import Intro from './sections/Intro/Intro';
import SolutionSlides from './sections/SolutionSlides/SolutionSlides';
import Solutions from './sections/Solutions/Solutions';
import Verification from './sections/Verification/Verification';

import './Landing.css';

const Landing = () => {
	const scrollable = useRef<HTMLDivElement>(null);
	const section = useScrollSelector('.landing-section', {
		scrollable,
		boundary: 0
	});
	return (
		<div id="landing" className={`page view-${section}`} ref={scrollable}>
			<Header section={section} />
			<ScrollDown scrollable={scrollable} />
			<HeroAnimation />
			<Intro scrollable={scrollable} />
			<Verification scrollable={scrollable} />
			<Designed scrollable={scrollable} />
			<Solutions scrollable={scrollable} />
			<SolutionSlides scrollable={scrollable} />
			<DataFacts scrollable={scrollable} />
			<Contact scrollable={scrollable} />
			<Footer />
		</div>
	);
};

export default Landing;
